<div class="page px-2 my-2">
  <div class="text-center" *ngIf="!hideHeader">
    <img src="/assets/logos/brand-logo-alt.svg" [alt]="brandName" height="100">
  </div>

  <div *ngIf="!signup">
    <ua-login-form (cancelClicked)="cancelLogin()"
                   [username]="username"
                   >
    </ua-login-form>
  </div>

  <ua-signup-form *ngIf="signup"
                  (signUpClicked)="createAccount($event)"
                  (backClicked)="cancel()"
                  (existingUserDetected)="toggleMode($event)"
                  [showTitle]="showTitle"
                  [emailAddress]="emailAddress"
                  [firstName]="firstName"
                  [lastName]="lastName"
                  [phoneNumber]="phoneNumber"
  ></ua-signup-form>

  <div *ngIf="authError" class="text-danger text-center mb-3">{{authError}}</div>
</div>
